const analyticsEventsName = {
  loginSuccessfuly: 'login_successfuly',
  loginFail: 'login_fail',
  notificationForeground: 'notification_foreground',
  notificationOpen: 'notification_open',
  notificationDismiss: 'notification_dismiss',
  notificationReceive: 'notification_receive',
  notificationRead: 'notification_read',
  balanceChecked: 'balance_checked',
  onlinePayment: 'online_payment',
  clickedAboutApp: 'clicked_about_app',
  ComplainManagement: 'Complain_Management',
  corporateApp: 'Corporate_App',
  corporateCall: 'Corporate_Call',
  corporateInternetBundles: 'Corporate_Internet_bundles',
  corporateInvoices: 'Corporate_Invoices',
  corporateReports: 'Corporate_Reports',
  corporateRoaming: 'Corporate_Roaming',
  corporateSIMSwap: 'Corporate_SIM_swap',
  corporateSMS: 'Corporate_SMS',
  corporateMCNService: 'Corporate_mcn_service',
  corporateOnlinePayment: 'Corporate_online_payment',
  corporateConnectYourLine: 'Corporate_connect_your_line',
  corporateLogout: 'Corporate_logout',
  corporateSupportTab: 'Corporate_Support_tab',
  corporateUsedReconnectAfterDisconnect:
    'Corporate_used_reconnect_after_disconnect',
  corporateTransactionHistory: 'Corporate_transaction_history',
  corporateTemporaryDeactivation: 'Corporate_temporary_deactivation',
  clickedMyServices: 'clicked_My_services',
  electronicBalanceRecharge: 'electronic_balance_recharge',
  subMigratedPackage: 'sub_migrated_package',
  transactionHistory: 'transaction_history',
  connectYourLine: 'Connect_your_line',
  usedReconnectAfterDisconnect: 'used_reconnect_after_disconnect',
  offersChecked: 'Offers_checked',
  OffersDetailsChecked: 'Offers_deatils_checked',
  switchNumberManagement: 'Switch_Number_Management',
  myUsageChecked: 'My_usage_checked',
  logout: 'logout',
  lastInvoiceChecked: 'Last_invoice_checked',
  minutesBundles: 'minutes_bundles',
  smsBundles: 'sms_bundles',
  internetBundles: 'internet_bundles',
  VASServices: 'VAS_services',
  romaingBundles: 'romaing_bundles',
  subReplaceFaf: 'sub_replace_faf',
  mcnService: 'mcn_service',
  balanceTransfer: 'balance_transfer',
  usageChecked: 'usage_checked',
  usedOnlineChat: 'used_online_chat',
  voucherRefill: 'voucher_refill',
  rating: 'feedback',
  FAQ: 'FAQ',
  nearestShowroomsChecked: 'nearest_showrooms_checked',
  puk: 'PUK',
  roamingTips: 'roaming_tips',
  contactUs: 'contact_us',
  videoChat: 'Video_chat',
  sentFreeSMS: 'sent_free_sms',
  internetSettings: 'internet_settings',
  switchBetweenNumbers: 'switch_Between_Numbers',
  corporateSwitchBetweenAccounts: 'Corporate_switch_Between_Accounts',
  JawwalEpayment: 'Jawwal_Epayment',
  agreeTermsConditions: 'Agree_terms_conditions',
  readTermsConditions: 'read_terms_conditions',
  subCheckedRoamingRates: 'sub_checked_roaming_rates',
  subEditedServicesBundleSmsVASCalls:
    'sub_edited_services_bundle_sms_VAS_calls',
  survey: 'Survey',
  used7awliLawSama7t: 'used_7awli_law_sama7t',
  usedMcbService: 'used_mcb_service',
  usedMixRefill: 'used_mix_refill',
  remainingInternet: 'Remaining_Internet',
  remainingSMS: 'Remaining_SMS',
  remainingMinutes: 'Remaining_Minutes',
  remainingOthers: 'Remaining_Others',
  jawwalApps: 'Jawwal_Apps',
  appSettings: 'App_settings',
  checkedAppServices: 'Checked_app_services',
  userProfile: 'user_profile',
  checked7arakatiPage: 'checked_7arakati_page',
  offersCheckedFixedLine: 'Offers_checked_fixed_line',
  offersDetailsCheckedFixedline: 'Offers_deatils_checked_fixed_line',
  homeScreenFixedline: 'home_screen_fixed_line',
  homeScreenJawwal: 'home_screen_jawwal',
  onlinePaymentFixedline: 'online_payment_fixed_line',
  upgradeSpeedOrder: 'upgrade_speed_order',
  upgradeSpeedView: 'upgrade_speed_view',
  quickAccessCustomize: 'quick_access_customize',
  notificationForegroundFixedline: 'notification_foreground_fixed_line',
  notificationOpenFixedline: 'notification_open_fixed_line',
  notificationDismissFixedline: 'notification_dismiss_fixed_line',
  notificationReceiveFixedline: 'notification_receive_fixed_line',
  notificationReadFixedline: 'notification_read_fixed_line',
  notificationShowMore: 'notification_show_more',
  notificationHide: 'notification_hide',
  notificationShowMoreFixedline: 'notification_show_more_fixed_line',
  notificationHideFixedline: 'notification_hide_fixed_line',
  clickedMyServicesFixedline: 'clicked_My_services_fixed_line',
  checkedAppServicesFixedline: 'Checked_app_services_fixed_line',
  switchBetweenNumbersFixedline: 'switch_between_numbers_fixed_line',
  paltelBook: 'paltel_book',
  fiberMigrationOrder: 'fiber_migration_order',
  fiberMigrationView: 'fiber_migration_view',
  newSubscribtionOrder: 'new_subscribtion_order',
  newSubscribtionView: 'new_subscribtion_view',
  troubleTicketOrder: 'trouble_ticket_order',
  troubleTicketView: 'trouble_ticket_view',
  usedOnlineChatFixedline: 'used_online_chat_fixed_line',
  planDetailsView: 'plan_details_view',
  planDetailsFixedlineView: 'plan_details_fixed_line_view',
  userProfileFixedline: 'user_profile_fixed_line',
  emailChangeFixedline: 'email_change_fixed_line',
  mobileNumberChangeFixedline: 'mobile_number_change_fixed_line',
  trackYourOrder: 'track_your_order',
  reconnectYourLineFixedline: 'reconnect_your_line_fixed_line',
}

export default analyticsEventsName
